import Cookies from 'js-cookie';
import { COOKIE_KEY as KEY, COOKIE_SECURE as SECURE } from '@/config/constanta';
import { getPinToken } from '@helpers/fetcher/token';

const getCookie = (k) => Cookies.get(k);

const setCookie = (k, v) => {
  if (v !== undefined && v !== null) {
    Cookies.set(k, v.toString(), SECURE);
  }
};

const removeCookie = (k) => Cookies.remove(k);

export const TokenManager = {
  // --------------------------------------------------
  // Core validation
  // --------------------------------------------------
  hasValidTokens: () => Boolean(getCookie(KEY.access_token) || getPinToken()),

  // --------------------------------------------------
  // Token getters
  // --------------------------------------------------
  getAccessToken: () => getCookie(KEY.access_token),
  getPinToken: () => getPinToken(),

  // --------------------------------------------------
  // Token setters
  // --------------------------------------------------
  setPinToken: (token) => setCookie(KEY.pin_token, token),
  setRefreshPinToken: (token) => setCookie(KEY.pin_refresh, token),

  // --------------------------------------------------
  // Device / PIN state getters
  // --------------------------------------------------
  getIsTrustedDevice: () => getCookie(KEY.is_trusted_device),
  getHaveTrustedDevice: () => getCookie(KEY.have_trusted_device),
  getIsDeviceSuspended: () => getCookie(KEY.is_device_suspended),
  getHasSetPin: () => getCookie(KEY.has_set_pin),
  getPinNeedChange: () => getCookie(KEY.pin_need_change),
  getIsPin6Digit: () => getCookie(KEY.is_pin_6digit),
  getNotificationToken: () => getCookie(KEY.notification_token),
  getHaveOtpToken: () => getCookie(KEY.have_otp_token),

  // --------------------------------------------------
  // Generic cookie helpers (exposed for backward-compat)
  // --------------------------------------------------
  setCookieData: setCookie,
  removeCookieData: removeCookie,
};
